<template>
    <div class='p-3' v-if='appointments.data && appointments.data.length'>
        <template v-for='appointment in appointments.data'>
            <div v-if='appointment.cancelled_at' :key='appointment.id' class="card card--patient appointment-reminder">
                <p>
                    {{moment(appointment.start_at).format('LLLL')}}<br>
                    {{translateLookupItem($root.lookup.appointment_types, appointment.appointment_type_id) | capitalise}} appointment with {{formatClinician(getAppointmentSessionTypeUser(appointment))}}
                    <template v-if='appointment.site_id'> at {{appointment.site.name}}</template>
                    
                </p>
                <p class="alert-warning">This appointment has been cancelled</p>
            </div>
            <div v-else-if='appointment.start_at' :key='appointment.id' class="card card--patient appointment-reminder">
                <p>
                    <span class="">{{moment(appointment.start_at).format('LLLL')}}</span><br>
                    {{translateLookupItem($root.lookup.appointment_types, appointment.appointment_type_id) | capitalise}} appointment with {{formatClinician(getAppointmentSessionTypeUser(appointment))}}
                    <template v-if='appointment.site_id'> at {{appointment.site.name}}</template>
                </p>
                <div class="d-flex justify-content-between mt-3">
                    <button v-on:click='deleteAppointment(appointment)' tag="button" class="btn btn-round btn-secondary">{{ $t('translations.cancel_appointment')}}</button>
                    <router-link :to='{path: "/booking/" + appointment.id}' tag="button" class="btn btn-round btn-primary ml-auto">{{ $t('translations.change_booking')}}</router-link>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
            appointments: [],
        }
    },
    mounted() {
         if(this.$root.isLoggedIn()) {
            this.getAppointments();
            window.Echo.private('appointment.' + this.$root.user.id)
                .listen('UpdateAppointment', (e) => {
                    this.getAppointments();
                });
         }
    },
    beforeDestroy() {
         if(this.$root.isLoggedIn()) {
            this.deinitData();
         }
    },
    
    methods: {
        deinitData() {
            window.Echo.leave('appointment.' + this.$root.user.id);
        },
        getAppointments() {
            axios.get('/api/vp1/appointments').then((res) => {
                this.appointments = res.data;

            }).catch((error) => {
                this.handleError(error, "create");
            });
        },
        deleteAppointment(appointment) {
            this.errors = [];
            this.$modal.show('dialog', {
					title: 'Cancel Appointment',
					text: "Are you sure you want to cancel this appointment?",
					buttons: [
					{
						title: 'Yes',
						handler: () => {
                            this.$modal.hide('dialog');
							this.setLoading(true);
                            return axios.delete(this.$root.apiBase + '/appointments/' + appointment.id).then((res) => {
                                this.setLoading(false);
                                this.getAppointments();
                            }).catch((error) => {
                                this.setLoading(false);
                                this.handleError(error, "delete");
                            });
						},
					},
					{
						title: 'Cancel',
						default: true
					}]});                    
        },
    }
}

</script>
